import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import SettingContext from '@/product/context/setting/settingContext'
import CommonContext from '@/product/context/common/commonContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { mapData } from '@/product/common/components'
import * as Yup from 'yup'
import Loaders from '@/product/components/molecules/Loaders'
import CustomDialog from '@/product/components/organisms/Dialog'
import TaxTableHistory from './TaxTableHistory'
import AuthContext from '@/product/context/auth/authContext'
import ReportContext from '@/product/context/report/reportContext'

const TaxTable = () => {
    const commonContext = useContext(CommonContext)
    const settingcontext = useContext(SettingContext)
    const authContext = useContext(AuthContext)
    const reportContext = useContext(ReportContext)

    const { user } = authContext
    const { getAllExportDownload } = reportContext
    const { allCounties, getAllCounties } = commonContext
    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        updateTaxTable,
        syncTaxTable,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [manageHistory, setManageHistory] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [isLoading, setIsLoading] = useState(true)
    const [changeStatus, setChangeStatus] = useState(false)
    const [notesPopup, setNotesPopup] = useState(false)
    const [taxEditPopup, setTaxEditPopup] = useState(false)

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const togglePopupHistory = (popup, status, id) => {
        if (popup) {
            setManageHistory({ popup, status, id })
        } else {
            setManageHistory({ popup, status: 'new', id: 0 })
        }
    }

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const changeNotesPopup = () => {
        setNotesPopup(!notesPopup)
    }

    const changeTaxEditPopup = () => {
        setTaxEditPopup(!taxEditPopup)
    }

    const [tableBody, setTableBody] = useState([])
    const [previousTax, setPreviousTax] = useState({})
    const taxEditFields = [
        { show: 'State Tax', value: 'state_tax' },
        { show: 'County Tax', value: 'county_tax' },
        { show: 'City Tax', value: 'city_tax' },
        { show: 'Transit Tax', value: 'transit_tax' },
    ]

    const acceptedDecimalFields = [
        'state_tax',
        'county_tax',
        'city_tax',
        'transit_tax',
    ]

    const resetFormikValues = (formik) => {
        formik?.setValues(formik?.initialValues)
        formik?.setTouched({}, false)
    }

    const tableActions = []

    const validationNotes = Yup.object({
        id: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        notes: Yup.string().required('Required!'),
    })

    const formikNotes = useFormik({
        initialValues: {
            id: 0,
            notes: '',
        },
        validationSchema: validationNotes,
        onSubmit: (values) => {
            console.log('formikNotes Values', values)
            setNotesPopup(false)
            toggleFullScreenPopup(true, 'edit', values.id)
        },
    })

    const validationTaxEdit = Yup.object({
        ids: Yup.array()
            .min(1, 'Please select at least one option')
            .required('Please select at least one option'),
        edit_tax: Yup.array()
            .min(1, 'Please select at least one option')
            .required('Please select at least one option'),
        notes: Yup.string().required('Required!'),
        state_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
        city_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
        county_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
        transit_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
    })

    const formikTaxEdit = useFormik({
        initialValues: {
            ids: [],
            edit_tax: [],
            multiple: true,
            state_tax: 0,
            city_tax: 0,
            county_tax: 0,
            transit_tax: 0,
            notes: '',
        },
        enableReinitialize: true,
        validationSchema: validationTaxEdit,
        onSubmit: (values) => {
            console.log('formikTaxEdit Values', values)
            setIsLoading(true)
            updateTaxTable(values)
            setTableBody([])
            setTaxEditPopup(false)
            resetFormikValues(formikTaxEdit)
        },
    })

    const addPrefixToKeys = (obj, prefix) => {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [prefix + key, value])
        )
    }

    const setPreviousTaxPayload = async (data, type) => {
        if (type === 'previous' && Object.keys(data).length && data.id) {
            const previousRecord = await addPrefixToKeys(data, 'previous_')
            setPreviousTax({
                ...previousRecord,
                id: 0,
                data_county_id: data?.id,
                country_code: data?.country_code,
                state_code: data?.state_code,
                city: data?.city,
                county: data?.county,
                zip: data?.zip,
                previous_state_tax: data?.state_tax,
                previous_city_tax: data?.city_tax,
                previous_county_tax: data?.county_tax,
                previous_transit_tax: data?.transit_tax,
                previous_additional_tax_label: data?.additional_tax_label,
                user_id: user.admin_id,
                active: 1,
                table: 'data_county_logs',
                noConfig: true,
            })
        } else if (
            type === 'current' &&
            Object.keys(data).length &&
            data.id &&
            Object.keys(previousTax).length
        ) {
            let updatedData = {
                ...previousTax,
                state_tax: data?.state_tax,
                city_tax: data?.city_tax,
                county_tax: data?.county_tax,
                transit_tax: data?.transit_tax,
                additional_tax_label: data?.additional_tax_label,
                notes: formikNotes.values.notes || '',
                noConfig: true,
            }
            searchTableAction(updatedData, true)
        }
    }

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                city: {
                    field: 'dc.city',
                    type: 'like',
                    value: '',
                },
                county: {
                    field: 'dc.county',
                    type: 'like',
                    value: '',
                },
                zip: {
                    field: 'dc.zip',
                    type: 'like',
                    value: '',
                },
                active: {
                    field: 'dc.active',
                    type: 'in',
                    value: '',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            setTableBody([])
            getAllCounties(values)
        },
    })

    const updateAllAgencyAddress = (data) => {
        const payload = {
            ...data,
            table: 'locations',
            updateValues: [data?.zip, data?.county, data?.city],
            updateKeys: ['zip', 'county', 'city'],
            noConfig: true,
        }
        searchTableAction(payload, true)
    }

    const validationArray = Yup.object({
        id: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        city: Yup.string().required('Required!').nullable(),
        county: Yup.string().required('Required!').nullable(),
        zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'The positive number only')
            .max(6, 'Maximum 6 characters')
            .required('Required'),
        state_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
        city_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
        county_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
        transit_tax: Yup.number()
            .typeError('Must be a number')
            .test('is-decimal', 'Invalid Value', (value) =>
                /^\d+(\.\d{1,3})?$/.test(value)
            ),
        additional_tax_label: Yup.string().nullable(),
    })

    const formikTax = useFormik({
        initialValues: {
            id: 0,
            city: '',
            county: '',
            zip: '',
            state_tax: 0,
            city_tax: 0,
            county_tax: 0,
            transit_tax: 0,
            additional_tax_label: '',
            active: 1,
            state_code: 'OH',
            country_code: 'US',
            table: 'data_county',
            noConfig: true,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            values.noConfig = true
            console.log('formikTax Values', values)
            setIsLoading(true)
            searchTableAction(values)
            updateAllAgencyAddress(values)
            setPreviousTaxPayload(values, 'current')
            toggleFullScreenPopup(false)
            setTableBody([])
            formikNotes.setValues({
                id: 0,
                notes: '',
            })
            formikNotes.setTouched({}, false)
        },
    })

    useEffect(() => {
        if (allCounties?.records) {
            setTableBody(allCounties.records)
            setIsLoading(false)
        }
    }, [allCounties])

    useEffect(() => {
        setTableBody([])
        setPreviousTax({})
        setIsLoading(true)
        formik.values.page = 1
        formik.values.filters.active.value = 1
        getAllCounties(formik.values)
    }, [])

    const onClickEdit = (id, secondaryID, type) => {
        formikNotes.setValues({
            id: 0,
            notes: '',
        })
        formikNotes.setFieldValue('id', id)
        setNotesPopup(true)
    }

    useEffect(() => {
        if (
            responseStatusSetting &&
            responseStatusSetting.status === 'success' &&
            responseStatusSetting.from === 'CommunicationSearchTable'
        ) {
            getAllCounties(formik.values)
        }
        if (
            responseStatusSetting &&
            responseStatusSetting.status === 'success' &&
            responseStatusSetting.from === 'updateTaxTable'
        ) {
            getAllCounties(formik.values)
        }
    }, [responseStatusSetting])

    const onClickHistory = (id, secondaryID, type) => {
        togglePopupHistory(true, 'history', id)
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Edit Tax Entry',
            },
            {
                buttonType: 'history',
                clickType: 'history',
                onclick: onClickHistory,
                tooltipTitle: 'See Changes History',
            },
        ]
        return actionPush
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Id',
            filterable: true,
            sortField: 'dc.id',
            filterField: 'dc.id',
        },
        {
            field: 'city',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'City',
            sortField: 'dc.city',
            filterable: true,
            filterField: 'dc.city',
        },
        {
            field: 'county',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'County',
            sortField: 'dc.county',
            filterable: true,
            filterField: 'dc.county',
        },
        {
            field: 'zip',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Zip',
            sortField: 'dc.zip',
            filterable: true,
            filterField: 'dc.zip',
        },
        {
            field: 'state_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'State Tax (%)',
            sortField: 'dc.state_tax',
            filterable: true,
            filterField: 'dc.state_tax',
        },
        {
            field: 'city_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'City Tax (%)',
            sortField: 'dc.city_tax',
            filterable: true,
            filterField: 'dc.city_tax',
        },
        {
            field: 'county_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'County Tax (%)',
            sortField: 'dc.county_tax',
            filterable: true,
            filterField: 'dc.county_tax',
        },
        {
            field: 'transit_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Transit Tax (%)',
            sortField: 'dc.transit_tax',
            filterable: true,
            filterField: 'dc.transit_tax',
        },
        {
            field: 'additional_tax_label',
            type: 'text',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Additional Tax Label',
            sortField: 'dc.additional_tax_label',
            filterable: true,
            filterField: 'dc.additional_tax_label',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            clickID: 'id',
            secondaryClickID: 'zip',
            isMultiple: getMultipleAction(),
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
        },
    ]

    const searchInfo = [
        {
            label: 'City',
            placeholder: 'Enter City',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'city',
            formik: formik,
            filter: true,
        },
        {
            label: 'County',
            placeholder: 'Enter County',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'county',
            formik: formik,
            filter: true,
        },
        {
            label: 'Zip',
            placeholder: 'Enter Zip',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'zip',
            formik: formik,
            filter: true,
        },
        {
            label: 'Status',
            placeholder: 'Select Status',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'select',
            name: 'active',
            formik: formik,
            filter: true,
            options: [
                { show: 'Active', value: '1' },
                { show: 'Inactive', value: '0' },
            ],
        },
    ]

    const taxFields = [
        {
            label: 'City',
            placeholder: 'Enter the City',
            type: 'text',
            class: 'col-12',
            name: 'city',
            disabled: user?.emp_type === 'super_admin' ? false : true,
            formik: formikTax,
        },
        {
            label: 'County',
            placeholder: 'Enter the County',
            type: 'text',
            class: 'col-12',
            name: 'county',
            disabled: user?.emp_type === 'super_admin' ? false : true,
            formik: formikTax,
        },
        {
            label: 'Zip',
            placeholder: 'Enter the Zip',
            type: 'text',
            class: 'col-12',
            name: 'zip',
            disabled: user?.emp_type === 'super_admin' ? false : true,
            formik: formikTax,
        },
        {
            label: 'State Tax (%)',
            placeholder: 'Enter the State Tax',
            type: 'text',
            class: 'col-12',
            name: 'state_tax',
            formik: formikTax,
        },
        {
            label: 'County Tax (%)',
            placeholder: 'Enter the County Tax',
            type: 'text',
            class: 'col-12',
            name: 'county_tax',
            formik: formikTax,
        },
        {
            label: 'City Tax (%)',
            placeholder: 'Enter the City Tax',
            type: 'text',
            class: 'col-12',
            name: 'city_tax',
            formik: formikTax,
        },
        {
            label: 'Transit Tax (%)',
            placeholder: 'Enter the Transit Tax',
            type: 'text',
            class: 'col-12',
            name: 'transit_tax',
            formik: formikTax,
        },
        {
            label: 'Additional Tax Label ',
            placeholder: 'Enter the Additional Tax Label',
            type: 'text',
            class: 'col-12',
            name: 'additional_tax_label',
            formik: formikTax,
        },
    ]

    const noteField = [
        {
            label: 'Document Number',
            placeholder: 'Enter the document number',
            type: 'text',
            class: 'col-12',
            name: 'notes',
            formik: formikNotes,
        },
    ]

    const taxEditField = {
        formik: formikTaxEdit,
        data: [
            {
                label: 'Document Number',
                placeholder: 'Enter the document number',
                type: 'text',
                class: 'col-12',
                name: 'notes',
            },
            {
                label: 'Tax Fields',
                placeholder: 'Select fields to Edit',
                type: 'autocomplete',
                class: 'col-12',
                name: 'edit_tax',
                multiple: true,
                options: taxEditFields,
                // options: taxEditFields.filter(
                //     (item) =>
                //         !formikTaxEdit.values.edit_tax?.includes(item.value)
                // ),
            },
            {
                label: 'State Tax (%)',
                placeholder: 'Enter the State Tax',
                type: 'text',
                class: `${
                    formikTaxEdit.values.edit_tax?.includes('state_tax')
                        ? ''
                        : 'd-none'
                } col-12`,
                name: 'state_tax',
            },
            {
                label: 'County Tax (%)',
                placeholder: 'Enter the County Tax',
                type: 'text',
                class: `${
                    formikTaxEdit.values.edit_tax?.includes('county_tax')
                        ? ''
                        : 'd-none'
                } col-12`,
                name: 'county_tax',
            },
            {
                label: 'City Tax (%)',
                placeholder: 'Enter the City Tax',
                type: 'text',
                class: `${
                    formikTaxEdit.values.edit_tax?.includes('city_tax')
                        ? ''
                        : 'd-none'
                } col-12`,
                name: 'city_tax',
            },
            {
                label: 'Transit Tax (%)',
                placeholder: 'Enter the Transit Tax',
                type: 'text',
                class: `${
                    formikTaxEdit.values.edit_tax?.includes('transit_tax')
                        ? ''
                        : 'd-none'
                } col-12`,
                name: 'transit_tax',
            },
            {
                label: 'Auto Excise Tax Approp',
                placeholder: 'Enter the Auto Excise Tax Approp',
                type: 'text',
                class: `${
                    formikTaxEdit.values.edit_tax?.includes('auto_excise_tax')
                        ? ''
                        : 'd-none'
                } col-6`,
                name: 'auto_excise_tax_approp',
            },
        ],
    }

    useEffect(() => {
        if (manage.status === 'edit' && manage.id) {
            formikTax.setFieldValue('id', manage.id)
            const existTax = tableBody.filter((cat) => cat.id === manage.id)
            if (existTax.length) {
                let editUpdateValue = existTax[0]

                formikTax.setValues({
                    ...formikTax.values,
                    ...editUpdateValue,
                })
                setPreviousTaxPayload(editUpdateValue, 'previous')
            }
        } else {
            resetFrom()
            setPreviousTax({})
        }
    }, [manage])

    const resetFrom = () => {
        formikTax.setValues({
            id: 0,
            city: '',
            county: '',
            zip: '',
            state_tax: 0,
            city_tax: 0,
            county_tax: 0,
            transit_tax: 0,
            additional_tax_label: '',
            active: 1,
            state_code: 'OH',
            country_code: 'US',
            table: 'data_county',
            noConfig: true,
        })
    }

    const decimalValueChange = (formik) => {
        Object.keys(formik?.values).map((buscat) => {
            if (acceptedDecimalFields.includes(buscat)) {
                let decimalValue = parseFloat(
                    formik.values[buscat] || 0
                ).toFixed(3)
                formik.values[buscat] = decimalValue
            }
        })
    }

    useEffect(() => {
        if (formikTax?.values) {
            decimalValueChange(formikTax)
        }
    }, [formikTax?.values])

    const formikSelection = useFormik({
        initialValues: {
            active: '',
            id: 0,
            table: 'data_county',
            noConfig: true,
        },
        onSubmit: (values) => {
            if (values.id) {
                setIsLoading(true)
                searchTableAction(values)
                setChangeStatus(false)
                setTableBody([])
            }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        if (action === 'active' || action === 'deactivate') {
            formikSelection.values.active = action === 'active' ? 1 : 0
            formikSelection.values.id = data
            setChangeStatus(true)
        } else if (action === 'edit_tax_entry') {
            formikTaxEdit.setFieldValue('ids', data)
            console.log('i am onSelectMultiProducts ', data)
            setTaxEditPopup(true)
        }
    }

    if (formik.values.filters.active.value == 1) {
        tableActions.push({
            label: 'Move to De-activate',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactivate',
        })
    }

    if (formik.values.filters.active.value == 0) {
        tableActions.push({
            label: 'Move to Activate',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        })
    }

    tableActions.push({
        label: 'Edit Tax Entry',
        icon: <span className="material-icons">edit</span>,
        onclick: onSelectMultiProducts,
        type: 'edit_tax_entry',
    })

    let exportFields = [
        {
            field: 'id',
            type: 'string',
            name: 'ID',
        },
        {
            field: 'city',
            type: 'string',
            name: 'City',
        },
        {
            field: 'county',
            type: 'string',
            name: 'County',
        },
        {
            field: 'zip',
            type: 'string',
            name: 'Zip',
        },
        {
            field: 'state_tax',
            type: 'decimal_percentage_three',
            name: 'State Tax (%)',
        },
        {
            field: 'city_tax',
            type: 'decimal_percentage_three',
            name: 'City Tax (%)',
        },
        {
            field: 'county_tax',
            type: 'decimal_percentage_three',
            name: 'County Tax (%)',
        },
        {
            field: 'transit_tax',
            type: 'decimal_percentage_three',
            name: 'Transit Tax (%)',
        },
        {
            field: 'additional_tax_label',
            type: 'string',
            name: 'Additional Tax Label ',
        },
        {
            field: 'active',
            type: 'string',
            name: 'Status',
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <>
                        <CustomSearch searchInfo={searchInfo} formik={formik} />
                        <Button
                            id="configView_variable_new"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() => syncTaxTable()}
                        >
                            <span className="material-icons">sync</span>
                            Sync Tax Table
                        </Button>
                        <div className="miscActions d-flex justify-content-between align-items-center mt-4 flex-wrap">
                            <div>
                                <Button
                                    id="configView_variable_new"
                                    variant="outlined"
                                    className="btnOutlined"
                                    onClick={() =>
                                        toggleFullScreenPopup(true, 'new', 0)
                                    }
                                >
                                    <span className="material-icons">
                                        note_add
                                    </span>
                                    Add New Tax Entry
                                </Button>
                            </div>
                            <Button
                                variant="outlined"
                                className="exportAllBtn"
                                onClick={() =>
                                    getAllExportDownload({
                                        fields: exportFields,
                                        replaceObjects: exportFields,
                                        action: 'export',
                                        isDefault: false,
                                        order: 'asc',
                                        orderby: '',
                                        search: 'all',
                                        report: `customData`,
                                        baseTable: 'data_county',
                                        customTable: false,
                                        topheading: 'Tax Table',
                                    })
                                }
                            >
                                <span className="material-icons">get_app</span>
                                Export All Data
                            </Button>
                        </div>
                        <CustomTable
                            formik={formik.values}
                            columnStorageVariable={'table_settings_tax_table'}
                            // columnVisibilityModel={{}}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={tableActions}
                            allData={allCounties}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getAllCounties}
                        />
                    </>
                )}
            </div>
            <FullScreenPopup
                modaltitle={
                    manage.status === 'new'
                        ? 'Add New Tax Entry'
                        : 'Edit Tax Entry'
                }
                open={manage.popup}
                handleClose={() => toggleFullScreenPopup(false, 'new', 0)}
            >
                <div className="dashboard addNewListing mt-4">
                    <div className="fspBody">
                        <form
                            onSubmit={formikTax.handleSubmit}
                            autoComplete="nofill"
                        >
                            <div className="row">
                                {Object.values(mapData(taxFields))}
                            </div>
                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <SecondaryButton
                                    id="location_cancel"
                                    label="Cancel"
                                    onClick={() => {
                                        toggleFullScreenPopup(false)
                                        setPreviousTax({})
                                    }}
                                />
                                <PrimaryButton
                                    id="formikTax_submit"
                                    type="submit"
                                    label="Submit"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </FullScreenPopup>
            <CustomDialog
                title={'Change Tax Entry Status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                <div className="actionWrapper">
                    <Button
                        id="tax_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="tax_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <CustomDialog
                title={'Document Number'}
                open={notesPopup}
                function={changeNotesPopup}
            >
                <h5>Please enter the document number to continue editing </h5>
                <div className="row">{Object.values(mapData(noteField))}</div>
                <div className="actionWrapper">
                    <Button id="tax_cancel" onClick={() => changeNotesPopup()}>
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikNotes.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="tax_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <TaxTableHistory
                data={manageHistory}
                function={togglePopupHistory}
            />
            <CustomDialog
                title={'Edit Tax Entry'}
                open={taxEditPopup}
                function={changeTaxEditPopup}
                className="taxEntryModal"
            >
                <h5>Select Tax Fields to Edit </h5>
                <div className="row">
                    {Object.values(mapData(taxEditField))}
                </div>
                <div className="actionWrapper">
                    <Button
                        id="tax_cancel"
                        onClick={() => changeTaxEditPopup()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikTaxEdit.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="tax_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default TaxTable
